var _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _filter, _filter2, _filter3, _filter4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 404.34 596.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    cy: 150.3,
    cx: -229.3,
    gradientTransform: "matrix(-.90164 .32787 -.34174 -.93979 -735.9 299.95)",
    r: 61.619
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    cy: 166.46,
    cx: -241.43,
    gradientTransform: "translate(-461.45 27.576) scale(.42623)",
    r: 61.619
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    cy: 595.21,
    cx: 435.97,
    gradientTransform: "matrix(-1.2088 1.2105 -.91742 -.91608 462.47 186.73)",
    r: 191.43
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff0"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8860b"
    },
    offset: 1
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    xlinkHref: "#a",
    gradientUnits: "userSpaceOnUse",
    cy: 150.3,
    cx: -229.3,
    gradientTransform: "matrix(-.90164 .32787 -.34174 -.93979 -384.69 366.72)",
    r: 61.619
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    xlinkHref: "#b",
    gradientUnits: "userSpaceOnUse",
    cy: 166.46,
    cx: -241.43,
    r: 61.619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff5ee"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#8b4513"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#dcdcdc"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    y2: 587.34,
    gradientUnits: "userSpaceOnUse",
    x2: 364.49,
    gradientTransform: "translate(-791.74 42.087)",
    y1: 465.92,
    x1: 364.65
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ba8a0b"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "gold"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    y2: 445.92,
    gradientUnits: "userSpaceOnUse",
    x2: 455.89,
    gradientTransform: "translate(-791.74 42.087)",
    y1: 391.82,
    x1: 356.1
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#b8860b"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6ef01"
    },
    offset: 1
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "e",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.465
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "f",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.376
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "m",
    height: 1.586,
    width: 1.17,
    colorInterpolationFilters: "sRGB",
    y: -0.293,
    x: -0.085
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.265
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "h",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.465
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "url(#c)"
    },
    d: "M-592.62 38.062c-25.244 0-46.944 15.175-56.469 36.906 40.895.296 81.825 13.583 116.09 40.312 1.306-4.983 2-10.2 2-15.594 0-34.031-27.594-61.625-61.625-61.625zm39.469 99.531zm-28.188 9.781z",
    transform: "translate(871.43 -33.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "url(#d)"
    },
    d: "M-564.34 72.25c-9.831 0-18.404 5.409-22.906 13.406a190.149 190.149 0 0 1 46.656 24 26.089 26.089 0 0 0 2.5-11.125c0-14.505-11.745-26.281-26.25-26.281z",
    transform: "translate(871.43 -33.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "#000"
    },
    d: "M-562.94 89.25a9.309 9.309 0 0 0-7.188 3.375 189.979 189.979 0 0 1 16.094 8.406c.225-.8.375-1.629.375-2.5a9.278 9.278 0 0 0-9.28-9.281z",
    transform: "translate(871.43 -33.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fillOpacity: 0.4539,
      filter: "url(#e)",
      fill: "#fff"
    },
    d: "M-592.62 38.062c-21.214 0-38.492 16.777-39.344 37.781 25.154 2.434 49.979 9.834 72.875 22.312 3.714-6.01 5.844-13.103 5.844-20.688 0-21.758-17.617-39.406-39.375-39.406z",
    transform: "translate(871.43 -33.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fillOpacity: 0.92574,
      filter: "url(#f)",
      fill: "snow"
    },
    d: "M-396.68 317.03c-2.503 0-4.682.972-5.875 2.438a189.996 189.996 0 0 1 11.375 5.53c.845-.83 1.344-1.853 1.344-2.968 0-2.761-3.065-5-6.844-5z",
    transform: "translate(701.18 -261.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "url(#g)"
    },
    d: "M-651.91 74.938c-52.062.382-103.78 21.879-141.25 63.719-70.532 78.757-63.882 199.78 14.875 270.31 76.544 68.55 193.01 64.166 264.25-8.438-70.196 50.426-291.47-96.438-291.47-96.438s191.5-169.49 272.84-169.31c10.782.024 20.5 2.64 28.719 8.532a191.547 191.547 0 0 0-18.938-19.562c-36.917-33.062-83.094-49.15-129.03-48.812zm143.66 318.87c-.232.467-.477.93-.75 1.375.343-.377.69-.744 1.031-1.125l-.281-.25z",
    transform: "translate(871.43 -33.216)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      filter: "url(#h)",
      fill: "#d3d3d3"
    },
    d: "M-179.81 166.46a61.619 61.619 0 1 1-123.24 0 61.619 61.619 0 1 1 123.24 0z",
    transform: "translate(374.8 -53.986)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "url(#i)"
    },
    d: "M-179.81 166.46a61.619 61.619 0 1 1-123.24 0 61.619 61.619 0 1 1 123.24 0z",
    transform: "translate(378.8 -58.556)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "url(#j)"
    },
    d: "M-179.81 166.46a61.619 61.619 0 1 1-123.24 0 61.619 61.619 0 1 1 123.24 0z",
    transform: "translate(263.98 52.114) scale(.42623)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fill: "#000"
    },
    d: "M-132.86 612.36a9.286 9.286 0 1 1-18.571 0 9.286 9.286 0 1 1 18.571 0z",
    transform: "translate(303.6 -488.016)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fillOpacity: 0.4539,
      filter: "url(#e)",
      fill: "#fff"
    },
    d: "M-179.81 166.46a61.619 61.619 0 1 1-123.24 0 61.619 61.619 0 1 1 123.24 0z",
    transform: "translate(291.73 -20.746) scale(.63934)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      fillOpacity: 0.92574,
      filter: "url(#f)",
      fill: "snow"
    },
    d: "M-132.86 612.36a9.286 9.286 0 1 1-18.571 0 9.286 9.286 0 1 1 18.571 0z",
    transform: "matrix(.73684 0 0 .53846 263.75 -211.105)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#k)"
    },
    d: "m-418.52 488.01-216.73 44.179s221.28 146.86 291.48 96.433c38.314-27.523-74.748-140.61-74.748-140.61z",
    transform: "translate(701.18 -261.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#l)"
    },
    d: "M-362.4 362.87c-81.34-.18-272.85 169.32-272.85 169.32l216.73-44.179s123.19-89.052 84.873-116.58c-8.226-5.91-17.953-8.539-28.75-8.562z",
    transform: "translate(701.18 -261.306)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      color: "#000",
      filter: "url(#m)",
      fill: "#a9a9a9"
    },
    d: "M-422.38 729.35c-.68 0-1.36.007-2.031.015-24.356.19-45.136 3.764-54.406 8.824-20.618-.037-41.211.714-60.938 2.253-6.803-.692-14.237-1.093-22.031-1.153-.672-.008-1.352-.015-2.031-.015-.68 0-1.329.007-2 .015-16.85.13-31.976 1.877-42.781 4.618-16.193 2.659-26.812 7.119-26.812 12.177 0 .343.06.687.156 1.025-57.05 18.787-46.598 45.238 27.219 61.07 76.545 16.419 193.01 15.369 264.25-2.02 2.15-.37 3.85-.804 5.094-1.295.322-.084.649-.169.968-.254l-.28-.06c17.728-8.53-80.5-32.062-80.5-32.062s123.04-21.313 84.905-27.916l-.062-.007c-5.84-1.667-12.163-3.24-18.938-4.693a389.3 389.3 0 0 0-10.156-2.028c1.298-1.192 2-2.444 2-3.734 0-7.988-26.5-14.488-59.594-14.744-.672-.008-1.352-.015-2.032-.015z",
    transform: "translate(701.18 -261.306)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/seven.9022bf41a70a7a41e63903596e5fecf2.svg";
export { ForwardRef as ReactComponent };